import React from 'react';
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ResourceModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

const ResourceModal: React.FC<ResourceModalProps> = ({ title, children, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 sm:p-6 md:p-8 overflow-y-auto">
      <div className="w-full max-w-4xl bg-gradient-to-b from-gray-900 to-black border border-gray-800 rounded-xl shadow-xl">
        <div className="sticky top-0 flex justify-between items-center p-4 sm:p-6 border-b border-gray-800 bg-black/50 backdrop-blur-sm">
          <h2 className="text-xl sm:text-2xl font-bold text-truth">{title}</h2>
          <Button variant="ghost" size="icon" onClick={onClose} className="rounded-full hover:bg-gray-800">
            <X className="h-5 w-5" />
          </Button>
        </div>
        <div className="p-4 sm:p-6 md:p-8 max-h-[calc(100vh-120px)] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ResourceModal;
